import React, { useEffect, useState } from 'react';
import { useVenue } from '../../hooks/useVenue';
import { eventService } from '../../services/eventService';
import styles from './GameTimeStrip.module.css';

export function computeGameStatus(
  kickoffAt: string | undefined,
  nowMs: number = Date.now()
): { icon: string; text: string } | null {
  if (!kickoffAt) return null;

  const kickoff = new Date(kickoffAt).getTime();
  if (Number.isNaN(kickoff)) return null;

  const diffMin = Math.round((kickoff - nowMs) / 60000);

  if (diffMin > 60) {
    return {
      icon: '🏟️',
      text: `Game starts in ${Math.round(diffMin / 60)} hr`,
    };
  }

  if (diffMin > 5) {
    return {
      icon: '🏟️',
      text: `Game starts in ${diffMin} min — order now to skip the line`,
    };
  }

  if (diffMin > -180) {
    return {
      icon: '🔴',
      text: 'Live — beat the rush',
    };
  }

  return null;
}

const GameTimeStrip: React.FC = () => {
  const { kickoffAt: venueKickoff } = useVenue();
  const [now, setNow] = useState(() => Date.now());
  const [gameKickoff, setGameKickoff] = useState<string | undefined>();

  useEffect(() => {
    const timer = window.setInterval(() => setNow(Date.now()), 60000);
    return () => window.clearInterval(timer);
  }, []);

  useEffect(() => {
    eventService.getActiveGameEvents().then((events) => {
      const active = events[0];
      if (active?.startDate) {
        setGameKickoff(active.startDate);
      }
    });
  }, []);

  const kickoffAt = gameKickoff || venueKickoff;
  const status = computeGameStatus(kickoffAt, now);

  if (!status) return null;

  return (
    <div className={styles.strip} role="status" aria-live="polite">
      <span className={styles.icon} aria-hidden="true">
        {status.icon}
      </span>
      <span className={styles.text}>{status.text}</span>
    </div>
  );
};

export default GameTimeStrip;
